import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Banknote, CreditCard, X } from "lucide-react";

interface PaymentMethodSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectCash: () => void;
  onSelectCard: () => void;
  orderTotal: number;
  orderNumber?: number;
}

export default function PaymentMethodSelector({
  isOpen,
  onClose,
  onSelectCash,
  onSelectCard,
  orderTotal,
  orderNumber,
}: PaymentMethodSelectorProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center">
            Seleccionar Método de Pago
          </DialogTitle>
          {orderNumber && (
            <p className="text-center text-muted-foreground text-sm">
              Pedido #{orderNumber}
            </p>
          )}
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Total a cobrar */}
          <div className="bg-primary/10 rounded-xl p-6 text-center border-2 border-primary/20">
            <p className="text-sm text-muted-foreground mb-1">TOTAL A COBRAR</p>
            <p className="text-4xl font-bold text-primary">
              {orderTotal.toFixed(2)}€
            </p>
          </div>

          {/* Opciones de pago */}
          <div className="space-y-3">
            {/* Efectivo */}
            <Button
              onClick={onSelectCash}
              className="w-full h-20 text-lg font-bold bg-green-600 hover:bg-green-700 text-white transition-all transform hover:scale-[1.02] active:scale-[0.98]"
            >
              <div className="flex items-center gap-4">
                <Banknote className="h-8 w-8" />
                <div className="text-left">
                  <p className="text-xl font-bold">💵 Efectivo</p>
                  <p className="text-sm opacity-90 font-normal">Abrir caja y calcular cambio</p>
                </div>
              </div>
            </Button>

            {/* Tarjeta */}
            <Button
              onClick={onSelectCard}
              className="w-full h-20 text-lg font-bold bg-blue-600 hover:bg-blue-700 text-white transition-all transform hover:scale-[1.02] active:scale-[0.98]"
            >
              <div className="flex items-center gap-4">
                <CreditCard className="h-8 w-8" />
                <div className="text-left">
                  <p className="text-xl font-bold">💳 Tarjeta</p>
                  <p className="text-sm opacity-90 font-normal">Pago con TPV bancario</p>
                </div>
              </div>
            </Button>
          </div>
        </div>

        {/* Botón cancelar */}
        <Button
          variant="outline"
          onClick={onClose}
          className="w-full h-12 border-2"
        >
          <X className="h-4 w-4 mr-2" />
          Cancelar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
